<template>
  <div id="frame">
    <div class="alert alert-warning" v-if="!$online">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Bitte stellen Sie eine Internetverbindung her!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <card :title="title" v-if="tick === 1" id="frame">
      <form>
      <v-text-field
        v-model="date"
        label="Datum"
        type="date"
      ></v-text-field>
      <v-text-field
        v-model="time"
        label="Uhrzeit"
        type="time"
      ></v-text-field>
        <v-text-field
          v-model="name"
          :error-messages="nameErrors"
          label="Ihr Name"
          @input="$v.name.$touch()"
          @blur="$v.name.$touch()"
          required
          clearable
          @click:clear="clearName()"
        ></v-text-field>
        <v-select
          v-model="artikelkategorie"
          :items="artikelkategorien"
          item-text="name"
          item-value="value"
          label="Artikelkategorie"
          return-object
          attach
          required
        ></v-select>
        <v-combobox
          v-model="artikel"
          :items="articlelist"
          :error-messages="artikelErrors"
          label="Artikel"
          @input="$v.artikel.$touch()"
          @blur="$v.artikel.$touch()"
          clearable
          attach
          @click:clear="clearArtikel()"
        ></v-combobox>
        <!-- <v-text-field
          v-model="artikel"
          :error-messages="artikelErrors"
          label="Artikel"
          @input="$v.artikel.$touch()"
          @blur="$v.artikel.$touch()"
          clearable
          @click:clear="clearArtikel()"
        ></v-text-field> -->
        <v-text-field
          v-model="artikelnummer"
          :error-messages="artikelnummerErrors"
          type="number"
          label="Vorgangsnummer"
          @input="$v.artikelnummer.$touch()"
          @blur="$v.artikelnummer.$touch()"
          clearable
          @click:clear="clearArtikelNummer()"
        ></v-text-field>
        <v-text-field
          v-model="temperatur"
          :error-messages="temperaturErrors"
          label="Kerntemperatur nach Garen"
          type="number"
          step="0.1"
          @input="$v.temperatur.$touch()"
          @blur="$v.temperatur.$touch()"
        ></v-text-field>
        <v-text-field
          v-model="bemerkung"
          :label="bemerkungLabel"
          required
          v-on:keyup.enter="nextTick()"
        ></v-text-field>
        <v-divider/>
        <!-- <v-btn @click="submit">submit</v-btn> -->
        <button class="btn btn-lg btn-danger float-left" v-on:click="goBack('cancelAdd')" type="button">abbrechen</button>
        <button class="btn btn-lg btn-success float-right" v-on:click="nextTick()" type="button">bestätigen</button>
      </form>
    </card>

    <card :title="title2" v-if="tick === 2" id="frame">
      <hr>
      <!-- bestätigen --> 
      <div class="angaben">
          <p class="messstelle">{{ title }}</p>
          <p>Datum: {{ formatDate(date) }}</p>
          <p>Uhrzeit: {{ time }}</p>
          <p>Ihr Name: {{ name }}</p>
          <p>Artikelkategorie: {{ artikelkategorie.name }}</p>
          <p>Artikel: {{ artikel }}</p>
          <p>Vorgangsnummer: {{ artikelnummer }}</p>
          <p>Temperatur: {{ temperatur }}°C</p>
          <p>Bemerkung: {{ bemerkung }}</p>
      </div>
      <hr>
      <div v-if="!this.question">
        <p class="messstelle">Wollen Sie noch einen weiteren Artikel hinzufügen?</p>
        <button class="btn btn-danger" v-on:click="changeQuestion()" type="button">Nein</button>
        <span class="buttonMargin"></span>
        <button class="btn btn-success" v-on:click="save('newArticle')" type="button">Ja</button>
      </div>
      <div v-if="this.question">
        <button class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button>
        <button class="btn btn-lg btn-success float-right" v-on:click="save()" type="button">bestätigen</button>
      </div>
    </card>

    <div class="alert alert-warning" v-if="showLoadingMessage && tick === 3" id="alert">
      <!-- Loading -->
      <button type="button" aria-hidden="true" class="close"></button>
      <center>
        <span>Eintrag wird erstellt, bitte warten</span>
        <br>
        <v-progress-circular :size="30" :width="7" color="red" indeterminate></v-progress-circular>
      </center>
    </div>
    <div class="alert alert-success" v-if="showSuccessMessage && tick === 3" id="alert">
      <!-- Erfoglsmeldung -->
      <button type="button" aria-hidden="true" class="close"></button>
      <span>
      <b>Erfolgreich erstellt! - </b> Ein entsprechender Eintrag wurde vorgenommen!</span>
    </div>
    <div class="alert alert-danger" v-if="showOnlineMessage && tick === 3 && $online">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Upload dauert länger. ({{ counterFront }} Sekunden)</b>
      </span>
      <!-- <button v-if="counterFront === 10" class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button> -->
    </div>
    <div class="alert alert-danger" v-if="showOnlineMessage && tick === 3 && !$online">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Stellen Sie eine Internetverbindung her. ({{ counterFront }} Sekunden)</b>
      </span>
      <!-- <button v-if="counterFront === 10" class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button> -->
    </div>
    <div class="alert alert-danger" v-if="showErrorMessage && tick === 4">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut</b>
      </span>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { numeric, required, alphaNum} from 'vuelidate/lib/validators';
import { helpers } from "vuelidate/lib/validators";

export const alphaDiacritic = helpers.regex('alphaDiacritic', /^[a-zA-ZÀ-ž ]*$/);

export default {
  mixins: [validationMixin],

  validations: {
      name: { required, alphaDiacritic },
      artikel: { required, alphaDiacritic },
      artikelnummer: { required },
      temperatur: {  required } ,
      date: { required }
  },
  data () {
    return {
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
      tick: 1,
      title: "Heiße Theke - Artikel eingeben",
      subtitle: "",
      title2: "Angaben bestätigen",
      counterFront: 0,
      temperatur: "",
      date: "",
      question: false,
      time:"",
      name: "",
      artikel: "",
      artikelnummer: "",
      artikelkategorie: "",
      artikelkategorien: [
        {name: "Hähnchen", value: 1},
        {name: "Schwein", value: 2},
        {name: "Sonstige", value: 3}
      ],
      bemerkung: "",
      showErrorMessage: false,
      showSuccessMessage: false,
      showOnlineMessage: false,
      showLoadingMessage: false,
      bemerkungLabel: "Bemerkung",
      routeBack: [],
      dst:[
        {year: 2019, start: "2019-03-31", ende: "2019-10-27"},
        {year: 2020, start: "2020-03-29", ende: "2020-10-25"},
        {year: 2021, start: "2021-03-28", ende: "2021-10-31"},
        {year: 2022, start: "2022-03-27", ende: "2022-10-30"},
        {year: 2023, start: "2023-03-26", ende: "2023-10-29"},
        {year: 2024, start: "2024-03-31", ende: "2024-10-27"},
        {year: 2025, start: "2025-03-30", ende: "2025-10-26"},
        {year: 2026, start: "2026-03-29", ende: "2026-10-25"},
        {year: 2027, start: "2027-03-28", ende: "2027-10-31"},
        {year: 2028, start: "2028-03-26", ende: "2028-10-29"},
        {year: 2029, start: "2029-03-25", ende: "2029-10-28"}
      ],
      articlelist: []
    }
  },

  mounted() {
    this.$http
      .get(
        process.env.VUE_APP_NODE_API_URL +
          "/heimspiel/qs/heissetheke/list/articles",
        { headers: { Authorization: this.auth } }
      )
      .then(function (response) {
        if (response.body.data) {
          response.body.data.map(article => this.articlelist.push(article.artikel));
        }
    });
  },
  
  methods: {
    search(input) {
      if (input.length < 1) { return [] }
      return this.articlelist.filter(article => {
        return article.toLowerCase()
          .startsWith(input.toLowerCase());
      })
    },
    clearName() {
      localStorage.removeItem('name');
      this.name = "";
    },
    clearArtikel() {
      localStorage.removeItem('artikel');
      this.artikel = "";
    },
    clearArtikelnummer() {
      this.artikelnummer = "";
    },
    saveName() {
      const parsed = JSON.stringify(this.name);
      localStorage.setItem('name', parsed);
    },
    disableNotification(){
      this.showErrorMessage = false;
    },
    changeQuestion() {
      this.question = !this.question;
    },
    fetchBereich(){
      //bereichsnmame & nummer aus db abrufendann title und subtitle belegen
      this.subtitle += this.$route.params.bereich;
    },
    nextTick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if((+this.temperatur <= 65 && (this.artikelkategorie.name === "Schwein" || this.artikelkategorie.name === "Sonstige")) ||
           (+this.temperatur <= 90 && this.artikelkategorie.name === "Hähnchen") &&
           _.isEmpty(this.bemerkung)) {
          this.bemerkungLabel = "Temp. zu niedrig! Bitte Bemerkung hinterlegen!"
        } else {
          this.tick++;
        }
      }
    },
    cancel(bool) {
      if (bool) {
        this.showSuccessMessage = false;
        this.createToday();
        this.temperatur = "";
        this.bemerkung = "";
        this.artikel = "";
        this.artikelnummer = "";
        this.tick = 1;
      } else {
        this.changeQuestion();
        this.tick = 1;
      }
    },
    goBack(index) {
      if (index < 0) {
        this.$router.go(index);
      } else if (index === 'cancelAdd') {
        this.$router.go(-1);
      }
    },
    formatDate(date){
      var today = new Date(date);
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var date = dd+ '.' + mm + '.' + yyyy;
      return date;
    },
    createToday() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var date = yyyy+ '-' + mm + '-' + dd;
      this.date = date;

      //DST check
      var thisYear= yyyy;
      var dstEnd;
      var dstStart;
      for (var i =0; i < this.dst.length; i++){
        if(this.dst[i].year == thisYear){
          dstEnd =  new Date(this.dst[i].ende);
          dstStart = new Date(this.dst[i].start);
        }
      }
      
      if(new Date(date) < dstEnd && new Date(date) >= dstStart ) {
        const tmpHour = (today.getUTCHours()+2) < 10 ? '0' + (today.getUTCHours()+2) : (today.getUTCHours()+2);
        if(+today.getUTCMinutes()<10) {
          this.time = tmpHour+ ':0' + today.getUTCMinutes();
        } else{
          this.time = tmpHour+ ':' + today.getUTCMinutes();
        }
      }else{
        const tmpHour = (today.getUTCHours()+1) < 10 ? '0' + (today.getUTCHours()+1) : (today.getUTCHours()+1);
        if(+today.getUTCMinutes()<10){
          this.time = tmpHour + ':0' + today.getUTCMinutes();
        } else{
          this.time = tmpHour + ':' + today.getUTCMinutes();
        }
      }
    },
    save(newArticle) {
      if (newArticle === 'newArticle') {
        let tmpDate = new Date(this.date);
        tmpDate.setHours(+this.time.slice(0,2), +this.time.slice(3,5));

        let articleLog = {
          datum: this.date,
          uhrzeit: this.time,
          artikel: this.artikel,
          artikelnummer: this.artikelnummer,
          artikelkategorie: this.artikelkategorie.name,
          sold: 0,
          ruined: 0,
          stufe: 0,

          firstTime: tmpDate,
          firstName: this.name,
          firstTemp: this.temperatur,
          firstBemerkung: this.bemerkung,

          sndTime: null,
          sndName: '',
          sndTemp: '',
          sndBemerkung: '',

          trdTime: null,
          trdName: '',
          trdTemp: '',
          trdBemerkung: '',

          timeSoldRuined: null
        }
        this.nextTick();
        this.showLoadingMessage = true;
        let counter = 0;
        let internetCounter = 0;
        var interval = setInterval(() => {
          if (this.$online && internetCounter === 0) {
            internetCounter = 1;
            this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/heissetheke/log/add', articleLog, { headers: {'Authorization': this.auth }})
              .then(function(response) {
                if(response.body.error) {
                  console.log(response.body.error);
                  this.nextTick();
                  this.showLoadingMessage = false;
                  this.showErrorMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.cancel(true), 1500);
                } else {
                  this.showLoadingMessage = false;
                  this.showOnlineMessage = false;
                  this.showSuccessMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.cancel(true), 1500);
                }
            });
          } else {
            this.counterFront++;
            if (counter === 3) {
              this.showOnlineMessage = true;
            }
          }
          counter++;
          if (counter === 10) {
            clearInterval(interval);
          }
        }, 1000);
      } else {
        let tmpDate = new Date(this.date);
        tmpDate.setHours(+this.time.slice(0,2), +this.time.slice(3,5));
        
        let articleLog = {
          datum: this.date,
          uhrzeit: this.time,
          artikel: this.artikel,
          artikelnummer: this.artikelnummer,
          artikelkategorie: this.artikelkategorie.name,
          sold: 0,
          ruined: 0,
          stufe: 0,

          firstTime: tmpDate,
          firstName: this.name,
          firstTemp: this.temperatur,
          firstBemerkung: this.bemerkung,

          sndTime: null,
          sndName: '',
          sndTemp: '',
          sndBemerkung: '',

          trdTime: null,
          trdName: '',
          trdTemp: '',
          trdBemerkung: '',

          timeSoldRuined: null
        }

        this.nextTick();
        this.showLoadingMessage = true;
        let counter = 0;
        let internetCounter = 0;
        var interval = setInterval(() => {
          if (this.$online && internetCounter === 0) {
            internetCounter = 1;
            this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/heissetheke/log/add', articleLog, { headers: {'Authorization': this.auth }})
              .then(function(response) {
                if(response.body.error) {
                  console.log(response.body.error);
                  this.nextTick();
                  this.showLoadingMessage = false;
                  this.showErrorMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.$router.push({path: "/qs/servicelisten/heissetheke", query: {routeBack: this.routeBack} }), 1500);
                } else {
                  this.showLoadingMessage = false;
                  this.showOnlineMessage = false;
                  this.showSuccessMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.$router.push({path: "/qs/servicelisten/heissetheke", query: {routeBack: this.routeBack} }), 1500);
                }
            });
          } else {
            this.counterFront++;
            if (counter === 0) {
              this.showOnlineMessage = true;
            }
          }
          counter++;
          if (counter === 10) {
            clearInterval(interval);
          }
        }, 1000);
      }
    },
  },
  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.required && errors.push('Bitte geben Sie Ihren Namen ein')
      !this.$v.name.alphaDiacritic && errors.push('Bitte keine Sonderzeichen eingeben')
      return errors
    },
    temperaturErrors () {
      const errors = []
      if (this.active) {  
        if (!this.$v.temperatur.$dirty) return errors
        !this.$v.temperatur.required && errors.push('Temperatur muss angegeben werden')
        return errors;
      } else {
        return errors;
      }
    },
    dateErrors () {
      const errors = []
      if (!this.$v.date.$dirty) return errors
      !this.$v.date.required && errors.push('Bitte wählen Sie ein Datum aus')
      return errors
    },
    artikelErrors () {
      const errors = []
      if (!this.$v.artikel.$dirty) return errors
      !this.$v.artikel.required && errors.push('Bitte geben Sie einen Artikel ein')
      !this.$v.artikel.alphaDiacritic && errors.push('Bitte keine Sonderzeichen eingeben')
      return errors
    },
    artikelnummerErrors () {
      const errors = []
      if (!this.$v.artikelnummer.$dirty) return errors
      !this.$v.artikelnummer.required && errors.push('Bitte geben Sie eine Artikelnummer ein')
      return errors
    },
  },
  created: function(){
    this.routeBack = this.$route.query.routeBack;
    if(this.$route.query){
      this.subtitle += " - "+this.$route.query.title;
    }
    this.createToday();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#frame{
    margin-left: 0%;
    margin-top: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;

}
.v-messages__message{
   color: rgb(255, 115, 0);
}
.instruction{
    text-align: center;
    font-weight: bold;
}
.pad{
  border: 2px solid rgb(117, 108, 108);
  border-radius: 5px ;
}
.messstelle{
  font-weight: bold;
  font-size: large;
}
.angaben{
  font-size: large;
  font-weight: bold;
}

.buttonMargin {
  margin-left: 5vh;
}

</style>

